<div class="row">
  <div class="col-xs-6">
    <p>
      <mat-form-field class="form-field form-full-width-field custome-class-close">
        <mat-label [innerHTML]="'$equipment_list_search_label' | translate"></mat-label>
        <input type="search" matInput [formControl]="itemSearchControl">
      <span class="searchhiddenToolTip">
        <mat-icon matSuffix>search</mat-icon>
        <span class="search-download-tool-tip" [innerHTML]="'$common_search' | translate"></span>
      </span>
      </mat-form-field>
    </p>
  </div>
  <div class="col-xs-5 col-xs-offset-1">
    <p>
      <mat-form-field class="form-field form-full-width-field">
        <mat-label [innerHTML]="'$equipment_list_workarea_filter_label' | translate"></mat-label>
        <mat-select panelClass="work-area-select" [formControl]="workAreaSelectControl">
          <mat-option [value]="-1" [innerHTML]="'$equipment_list_workarea_filter_all_selection' | translate"></mat-option>
          <mat-option *ngFor="let workArea of workAreas" [value]="workArea.id">{{workArea.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </p>
  </div>
</div>
<div class="row export-error-msg" *ngIf="showExportErrorMessage">
  <div class="col-xs-6 col-xs-offset-3 text-center">
    <span [innerHTML]="'$reports_card_dialog_error_select_row' | translate"></span>
  </div>
</div>
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title class="truncate">
      {{installedView ? ('$equipment_list_installed_title' | translate) : ('$equipment_list_recommended_title' | translate)}}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-toolbar color="accent" class="list-title-bar">
    <!--Installed Equipment view-->
    <mat-toolbar-row *ngIf="installedView">
      <div class="row header-container middle-xs" matSort (matSortChange)="sortData($event)">
        <div class="col-xs-1" *ngIf="!readonly">
          <mat-checkbox #selectAllCheckbox (change)="checkUncheckAll($event)"></mat-checkbox>
          <button mat-icon-button class="sort-checked-users" (click)="sortChecked()">
            <mat-icon>swap_vert</mat-icon>
          </button>
        </div>
        <div class="col-xs-3">
          <span mat-sort-header="item"><span [innerHTML]="'$equipment_config_item_label' | translate"></span></span>
        </div>
        <div class="col-xs-2">
          <span mat-sort-header="category"><span [innerHTML]="'$equipment_list_category_col_label' | translate"></span></span>
        </div>
        <div class="col-xs-3">
            <span mat-sort-header="workArea"><span [innerHTML]="'$employee_equipment_workarea_label' | translate"></span></span>
        </div>
        <div class="col-xs-2">
          <span mat-sort-header="installedDate"><span [innerHTML]="'$equipment_list_installed_col_label' | translate"></span></span>
        </div>
        <div class="col-xs-1 end-xs bulk-actions" *ngIf="!readonly">
          <!-- <mat-icon class="link" [matMenuTriggerFor]="exportRecommendedMenu">cloud_download</mat-icon> -->
          <div class="hiddenToolTip">
            <mat-icon class="link" [matMenuTriggerFor]="exportRecommendedMenu">cloud_download</mat-icon>
            <span class="download-tool-tip">{{'$lng_eu_download' | translate}}</span>
          </div>
          <mat-menu #exportRecommendedMenu="matMenu">
            <button mat-menu-item (click)="doBulkAction(false)" [innerHTML]="'$equipment_list_exporttoexcel_label' | translate"></button>
            <button mat-menu-item (click)="doBulkAction(true)" [innerHTML]="'$equipment_list_exporttopdf_lable' | translate"></button>
          </mat-menu>
        </div>
      </div>
    </mat-toolbar-row>
    <!--Recommended Equipment view-->
    <mat-toolbar-row *ngIf="!installedView">
      <div class="row header-container" matSort (matSortChange)="sortData($event)">
        <div class="col-xs-1" *ngIf="!readonly">
          <mat-checkbox #selectAllCheckbox (change)="checkUncheckAll($event)"></mat-checkbox>
          <button mat-icon-button class="sort-checked-users" (click)="sortChecked()">
            <mat-icon>swap_vert</mat-icon>
          </button>
        </div>
        <div class="col-xs-2">
          <span mat-sort-header="item"><span [innerHTML]="'$equipment_config_item_label' | translate"></span></span>
        </div>
        <div class="col-xs-2">
          <span mat-sort-header="category"><span [innerHTML]="'$equipment_list_category_col_label' | translate"></span></span>
        </div>
        <div class="col-xs-2">
            <span mat-sort-header="workArea"><span [innerHTML]="'$employee_equipment_workarea_label' | translate"></span></span>
        </div>
        <div class="col-xs-2">
          <span mat-sort-header="status"><span [innerHTML]="'$equipment_list_status_col_label' | translate"></span></span>
        </div>
        <div class="col-xs-2">
          <span mat-sort-header="recommendedDate"><span [innerHTML]="'$equipment_list_recommended_date_col_label' | translate"></span></span>
        </div>
        <div class="col-xs-1 end-xs bulk-actions" *ngIf="!readonly">
          <!-- <mat-icon class="link" [matMenuTriggerFor]="exportRecommendedMenu">cloud_download</mat-icon> -->
          <div class="hiddenToolTip">
            <mat-icon class="link" [matMenuTriggerFor]="exportRecommendedMenu">cloud_download</mat-icon>
            <span class="download-tool-tip">{{'$lng_eu_download' | translate}}</span>
          </div>
          <mat-menu #exportRecommendedMenu="matMenu">
            <button mat-menu-item (click)="doBulkAction(false)" [innerHTML]="'$equipment_list_exporttoexcel_label' | translate"></button>
            <button mat-menu-item (click)="doBulkAction(true)" [innerHTML]="'$equipment_list_exporttopdf_lable' | translate"></button>
          </mat-menu>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <!--Installed view list items-->
  <div class="list-items" [formGroup]="exportForm" *ngIf="filteredEquipment && installedView">
    <div class="item row middle-xs" *ngFor="let workFlow of filteredEquipment">
      <div class="col-xs-1" *ngIf="!readonly">
        <mat-checkbox [formControlName]="workFlow.id"></mat-checkbox>
      </div>
      <div class="col-xs-3">
        <span>{{workFlow.equipmentItem.title}}</span>
      </div>
      <div class="col-xs-2">
        <span>{{workFlow.equipmentItem.equipmentCategoryLabel}}</span>
      </div>
      <div class="col-xs-3">
        <span>{{workFlow.equipmentItem.workAreaLabel}}</span>
      </div>
      <div class="col-xs-2">
        <span>{{workFlow.equipmentItem.installedDate | date:'MM-dd-yyyy'}}</span>
      </div>
      <div class="col-xs-1 end-xs hiddenToolTip" *ngIf="!readonly">
        <mat-icon class="link" (click)="openEquipmentDialog(workFlow)">open_in_new</mat-icon>
        <span class="download-tool-tip" [innerHTML]="'$common_details' | translate"></span>
      </div>
    </div>
  </div>
  <!--Recommended view list items-->
  <div class="list-items" [formGroup]="exportForm" *ngIf="filteredEquipment && !installedView">
    <div class="item row middle-xs" *ngFor="let workFlow of filteredEquipment">
      <div class="col-xs-1" *ngIf="!readonly">
        <mat-checkbox [formControlName]="workFlow.id"></mat-checkbox>
      </div>
      <div class="col-xs-2">
        <span>{{workFlow.equipmentItem.title}}</span>
      </div>
      <div class="col-xs-2">
        <span>{{workFlow.equipmentItem.equipmentCategoryLabel}}</span>
      </div>
      <div class="col-xs-2">
        <span>{{workFlow.equipmentItem.workAreaLabel}}</span>
      </div>
      <div class="col-xs-2">
        <span [ngClass]="{'status-draft': workFlow.isDraft}">{{workFlow.statusHistory[0].statusTypeLabel}}</span>
      </div>
      <div class="col-xs-2">
        <span>{{workFlow.equipmentItem.recommendedDate | date:'MM-dd-yyyy'}}</span>
      </div>
      <div class="col-xs-1 end-xs bulk-actions hiddenToolTip" *ngIf="!readonly">
        <mat-icon class="link" (click)="openEquipmentDialog(workFlow)">open_in_new</mat-icon>
        <span class="download-tool-tip" [innerHTML]="'$common_details' | translate"></span>
      </div>
    </div>
  </div>
</mat-expansion-panel>
<div class="row add-button" *ngIf="!readonly">
  <div class="col-xs center-xs">
    <button mat-flat-button color="accent" (click)="openEquipmentDialog()">
      {{installedView ? ('$equipment_list_add_installed_btn' | translate) : ('$equipment_list_add_recommended_btn' | translate)}}
    </button>
  </div>
</div>